import AppPage from '../../mixins/app-page'
import Gateway from '../../utils/global/Gateway'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'page-debug',

    mixins:
    [
        AppPage
    ],

    components: {},

    data()
    {
        return {
            data: []
        }
    },

    created()
    {
        for (const key in URL.api)
        {
            if (key !== 'article'
                && key !== 'videoPlayer'
                && key !== 'esMatchDetails'
                && key !== 'teamProfile'
                && key !== 'player')
            {
                this._addLine(key, URL.api[key], {}, key)
            }
        }
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
    },

    methods:
    {
        _addLine(name, src, dataGet = {}, code)
        {
            const tStart = Date.now()
            src = src.replace(':lang', 'uk')
            const line = {
                name,
                src,
                success: 0,
                message: '',
                time: 0
            }
            this.data.push(line)

            Gateway.getInstance().send(
                src,
                data => // data
                {
                    line.success = 1
                    // console.log('%cAPI%c connected', 'color: #4f4f4f;', 'color: #129725;')
                    line.time = Date.now() - tStart

                    switch (code)
                    {
                    case 'news':
                        for (const obj of data.list)
                        {
                            const slug = obj.slug
                            const url = URL.api.article + '?slug=' + slug
                            this._addLine('article/' + slug, url, {slug}, 'article')
                        }
                        break
                    case 'videos':
                        for (const obj of data.list)
                        {
                            const slug = obj.slug
                            const url = URL.api.videoPlayer + '?slug=' + slug
                            this._addLine('videos/' + slug, url, {slug}, 'videoPlayer')
                        }
                        break
                    case 'esMatches':
                        for (const obj of data.list)
                        {
                            const slug = obj.slug
                            const url = URL.api.esMatchDetails + '?slug=' + slug
                            this._addLine('matches/' + slug, url, {slug}, 'esMatchDetails')
                        }
                        break
                    case 'teams':
                        for (const obj of data.list)
                        {
                            const slug = obj.slug
                            const url = URL.api.teamProfile + '?slug=' + slug
                            this._addLine('team/' + slug, url, {slug}, 'teamProfile')
                        }
                        break
                    case 'teamProfile':
                        for (const obj of data.players.list)
                        {
                            const slug = obj.slug
                            const url = URL.api.player + '?slug=' + slug
                            this._addLine('player/' + slug, url, {slug}, 'player')
                        }
                        break
                    default:
                    }
                },
                msg =>
                {
                    line.success = -1
                    line.message = msg
                    line.time = Date.now() - tStart
                    // console.error('%cAPI%c not connected (' + msg + ')', 'color: #4f4f4f;', 'color: #e62932;')
                },
                dataGet)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-debug/script.js